import { createTheme } from "@mui/material/styles";
import { getColorHexCodeByColorName as token } from "./tokens";

/**
 * MUI theme for the task pane. Tailwind owns most of the visual layer
 * (colors, layout, custom utilities); this theme just guarantees that
 * any unstyled MUI primitives — TextField focus rings, default buttons —
 * pick up Highstreet brand tokens instead of MUI's blue defaults.
 *
 * Colour values come from `src/tokens.ts` — the same module `tailwind.config.ts`
 * reads — so a theme value can never drift from its utility class.
 */
export const theme = createTheme({
  palette: {
    primary: {
      main: token("sunrise"),
      light: token("lotus"),
      dark: token("blossom"),
      contrastText: token("primary-gray-light-900"),
    },
    secondary: {
      main: token("primary-gray-light-600"),
      contrastText: token("base-white"),
    },
    success: {
      main: token("primary-success-700"),
    },
    warning: {
      main: token("primary-warning-700"),
    },
    error: {
      main: token("primary-error-700"),
    },
    text: {
      primary: token("primary-gray-light-900"),
      secondary: token("primary-gray-light-600"),
    },
    background: {
      default: token("primary-gray-light-25"),
      paper: token("base-white"),
    },
    divider: token("primary-gray-light-200"),
  },
  typography: {
    fontFamily: '"Roboto", "Calibri Bold", "Segoe UI", "Helvetica", "Arial", sans-serif',
    fontSize: 14,
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiButton: {
      defaultProps: { size: "small" },
      styleOverrides: {
        root: {
          textTransform: "none",
          fontWeight: 600,
        },
      },
    },
    MuiTextField: {
      defaultProps: { size: "small", variant: "outlined" },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: token("primary-gray-light-300"),
          },
          "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: token("primary-gray-light-400"),
          },
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: token("sunrise"),
            borderWidth: "1px",
          },
        },
      },
    },
  },
});
